export const SubscriptionTypes: any = {
  FreeProduct: 'Screener',
  DiagnosticProduct: 'Diagnostic',
  FullProduct: 'System',
}
